webpackJsonp([0],{

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(375)
}
var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(372),
  /* template */
  __webpack_require__(378),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 372:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_shared__ = __webpack_require__(36);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  mixin: [__WEBPACK_IMPORTED_MODULE_0__mixins_shared__["a" /* default */]],
  $_veeValidate: {
    validator: 'new'
  },
  mounted: function mounted() {
    this.$validator.localize('en', this.dictionary);
  },
  data: function data() {
    return {
      loading: false,
      valid: true,
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      confirmPassword: '',
      telephone: '',
      address1: '',
      address2: '',
      town: '',
      county: '',
      postcode: '',
      dictionary: {
        attributes: {
          email: 'E-mail Address'
        }
      }
    };
  },

  computed: {
    comparePasswords: function comparePasswords() {
      return this.password !== this.confirmPassword ? 'Passwords do not match' : '';
    },
    user: function user() {
      return this.$store.getters.user;
    }
  },
  watch: {
    user: function user(value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/issue-type');
      }
    }
  },
  methods: {
    onSignup: function onSignup() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this.loading = true;
          _this.$fb.auth().createUserWithEmailAndPassword(_this.email, _this.password).then(function (user) {
            var newUser = {
              firstName: _this.firstName,
              lastName: _this.lastName,
              telephone: _this.telephone,
              address1: _this.address1,
              address2: _this.address2,
              town: _this.town,
              county: _this.county,
              postcode: _this.postcode,
              email: user.email,
              approved: true,
              role: 'User'
            };
            _this.$db.collection('userMeta').doc(user.uid).set(newUser).catch(function (error) {
              _this.addNotification({ text: error.message, color: 'error' });
              _this.loading = false;
              console.log(error);
            });
            _this.loading = false;
            _this.$store.dispatch('signUserUp', newUser);
          }).catch(function (error) {
            _this.addNotification({ text: error.message, color: 'error' });
            _this.loading = false;
          });
        }
      });
    }
  }
});

/***/ }),

/***/ 373:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(365)(true);
// imports


// module
exports.push([module.i, "@media only screen and (max-width:800px){.pfCard.v-card{background-color:transparent;padding:0;-webkit-box-shadow:none;box-shadow:none}.pfCard .v-card__text{padding:0}}.logo{height:45px;width:auto}.logo-span{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;position:relative;text-align:center;vertical-align:middle}", "", {"version":3,"sources":["C:/apps/prop/src/components/User/Signup.vue"],"names":[],"mappings":"AACA,yCACA,eACI,6BAA8B,AAC9B,UAAY,AACZ,wBAAyB,AACjB,eAAgB,CAC3B,AACD,sBACI,SAAY,CACf,CACA,AACD,MACE,YAAa,AACb,UAAY,CACb,AACD,WACE,2BAA4B,AAC5B,2BAA4B,AAC5B,oBAAqB,AACrB,yBAA0B,AAC5B,sBAAuB,AACvB,mBAAoB,AACpB,wBAAyB,AACzB,qBAAsB,AACtB,uBAAwB,AACxB,kBAAmB,AACnB,kBAAmB,AACnB,qBAAuB,CACtB","file":"Signup.vue","sourcesContent":["\n@media only screen and (max-width : 800px) {\n.pfCard.v-card {\r\n    background-color: transparent;\r\n    padding:  0;\r\n    -webkit-box-shadow: none;\r\n            box-shadow: none\n}\n.pfCard .v-card__text {\r\n    padding:  0;\n}\n}\n.logo {\r\n  height: 45px;\r\n  width: auto;\n}\n.logo-span {\r\n  display: -webkit-inline-box;\r\n  display: -ms-inline-flexbox;\r\n  display: inline-flex;\r\n  -webkit-box-align: center;\r\n-ms-flex-align: center;\r\nalign-items: center;\r\n-webkit-box-pack: center;\r\n-ms-flex-pack: center;\r\njustify-content: center;\r\nposition: relative;\r\ntext-align: center;\r\nvertical-align: middle;\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 375:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(373);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(366)("96ab3af8", content, true, {});

/***/ }),

/***/ 378:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('v-card', {
    staticClass: "margin-top-card pfCard"
  }, [(_vm.loading) ? _c('v-progress-linear', {
    attrs: {
      "indeterminate": true
    }
  }) : _vm._e(), _vm._v(" "), _c('v-card-text', [_c('v-container', [_c('h2', [_vm._v("Register with us")]), _vm._v(" "), _c('v-form', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:2|max:30'),
      expression: "'required|min:2|max:30'"
    }],
    attrs: {
      "name": "firstName",
      "label": "First Name",
      "id": "firstName",
      "error-messages": _vm.errors.collect('firstName'),
      "data-vv-name": "firstName",
      "required": ""
    },
    model: {
      value: (_vm.firstName),
      callback: function($$v) {
        _vm.firstName = $$v
      },
      expression: "firstName"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:2|max:30'),
      expression: "'required|min:2|max:30'"
    }],
    attrs: {
      "name": "lastName",
      "label": "Last Name",
      "id": "lastName",
      "error-messages": _vm.errors.collect('lastName'),
      "data-vv-name": "lastName",
      "required": ""
    },
    model: {
      value: (_vm.lastName),
      callback: function($$v) {
        _vm.lastName = $$v
      },
      expression: "lastName"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "name": "email",
      "label": "Email Address",
      "id": "email",
      "error-messages": _vm.errors.collect('email'),
      "data-vv-name": "email",
      "required": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:8'),
      expression: "'required|min:8'"
    }],
    attrs: {
      "name": "password",
      "label": "Password",
      "id": "password",
      "error-messages": _vm.errors.collect('password'),
      "data-vv-name": "password",
      "type": "password",
      "required": ""
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:password'),
      expression: "'required|confirmed:password'"
    }],
    attrs: {
      "name": "confirmPassword",
      "label": "Confirm Password",
      "id": "confirmPassword",
      "error-messages": _vm.errors.collect('confirmPassword'),
      "data-vv-as": "password",
      "type": "password",
      "required": ""
    },
    model: {
      value: (_vm.confirmPassword),
      callback: function($$v) {
        _vm.confirmPassword = $$v
      },
      expression: "confirmPassword"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:30'),
      expression: "'required|max:30'"
    }],
    attrs: {
      "name": "telephone",
      "label": "Telephone",
      "id": "telephone",
      "error-messages": _vm.errors.collect('telephone'),
      "data-vv-name": "telephone",
      "required": ""
    },
    model: {
      value: (_vm.telephone),
      callback: function($$v) {
        _vm.telephone = $$v
      },
      expression: "telephone"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:30'),
      expression: "'required|max:30'"
    }],
    attrs: {
      "name": "address1",
      "label": "Address Line 1",
      "id": "address1",
      "error-messages": _vm.errors.collect('address1'),
      "data-vv-name": "address1",
      "required": ""
    },
    model: {
      value: (_vm.address1),
      callback: function($$v) {
        _vm.address1 = $$v
      },
      expression: "address1"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:30'),
      expression: "'required|max:30'"
    }],
    attrs: {
      "name": "address2",
      "label": "Address Line 2",
      "id": "address2",
      "error-messages": _vm.errors.collect('address2'),
      "data-vv-name": "address2",
      "required": ""
    },
    model: {
      value: (_vm.address2),
      callback: function($$v) {
        _vm.address2 = $$v
      },
      expression: "address2"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:30'),
      expression: "'required|max:30'"
    }],
    attrs: {
      "name": "town",
      "label": "Town/City",
      "id": "town",
      "error-messages": _vm.errors.collect('town'),
      "data-vv-name": "town",
      "required": ""
    },
    model: {
      value: (_vm.town),
      callback: function($$v) {
        _vm.town = $$v
      },
      expression: "town"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:30'),
      expression: "'required|max:30'"
    }],
    attrs: {
      "name": "county",
      "label": "County",
      "id": "county",
      "error-messages": _vm.errors.collect('county'),
      "data-vv-name": "county",
      "required": ""
    },
    model: {
      value: (_vm.county),
      callback: function($$v) {
        _vm.county = $$v
      },
      expression: "county"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:30'),
      expression: "'required|max:30'"
    }],
    attrs: {
      "name": "postcode",
      "label": "Postcode",
      "id": "postcode",
      "error-messages": _vm.errors.collect('postcode'),
      "data-vv-name": "postcode",
      "required": ""
    },
    model: {
      value: (_vm.postcode),
      callback: function($$v) {
        _vm.postcode = $$v
      },
      expression: "postcode"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [(!_vm.loading) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "ripple": "",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.onSignup
    }
  }, [_vm._v("\n                    Sign up\n                  ")]) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Already have and account?")])], 1)], 1)])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/0.cc2168d935f283eec89c.js